<!--
 * @Author: 汪俊洪
 * @Date: 2021-09-18 16:03:01
 * @LastEditors: 汪俊洪
 * @LastEditTime: 2024-01-02 15:33:27
 * @Description: 关闭订单
-->
<template>
  <el-form :model="input" :rules="rules" ref="input" label-width="90px">
    <el-form-item label="操作备注" prop="cancelRemark">
      <el-input
        type="textarea"
        maxlength="500"
        :autosize="{ minRows: 3, maxRows: 10 }"
        resize="none"
        show-word-limit
        v-model="input.cancelRemark"
      ></el-input>
    </el-form-item>
    <el-form-item class="right">
      <el-button @click="cancel">取消</el-button>
      <el-button type="primary" @click="submitForm">确定</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  data () {
    return {
      input: {
        cancelRemark: ''
      },
      rules: {
        cancelRemark: [
          { required: true, message: '请输入操作备注', trigger: 'blur' },
          { min: 4, max: 500, message: '最少输入4个字符', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    submitForm () {
      this.$refs.input.validate((valid) => {
        if (valid) {
          this.$emit('submit', this.input)
        }
      })
    },
    cancel () {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
.right {
  text-align: right;
  padding-top: 20px;
}
::v-deep .el-textarea .el-input__count {
  line-height: 18px;
}
</style>
